import { render } from "./WalletPanel.vue?vue&type=template&id=2b499738&scoped=true"
import script from "./WalletPanel.vue?vue&type=script&lang=js"
export * from "./WalletPanel.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2b499738"

export default script